import {bookmarks_mark_Api, bookmarks_unMark_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {LoginContext} from 'components/LoginContext'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useState} from 'react'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {AppEntities} from '../enums'
import {notifyOnError} from '../factory/createErrorEvent'
import {bindQueryParams} from '../functions/routerHelper'
import {Modal} from "antd";
import {useHistory} from "react-router-dom";
import {staticPaths} from "../../../routes/staticPaths";
import {BsBookmarkCheckFill, BsBookmarkX} from "react-icons/bs";

const getSettings = (name, defaultValue) => {
    const json = localStorage.getItem(name)
    try {
        return JSON.parse(json) ?? defaultValue
    } catch (error) {
        return defaultValue
    }
}

const useCodiSettings = ({
                             name,
                             defaultValue,
                             onSync = NullAsDefault,
                             setLoading = NullAsDefault,
                         }) => {
    const [values, setValues] = useState()

    useEffect(() => {
        function onStorageChange() {
            const settings = getSettings(name, defaultValue)
            setValues(settings)
        }

        onStorageChange()
        window.addEventListener('my_storage', onStorageChange)
        return () => {
            window.removeEventListener('my_storage', onStorageChange)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const commit = (obj, willSync = true) => {
        if (_.isEmpty(obj)) return
        setLoading(true)
        setTimeout(() => {
            const current_settings = getSettings(name, defaultValue)
            const data = {
                ...(defaultValue ?? {}),
                ...(current_settings ?? {}),
                ...(obj ?? {}),
            }
            localStorage.setItem(name, JSON.stringify(data))
            window.dispatchEvent(new Event('my_storage'))
            setValues(data)
            if (willSync) {
                onSync(data)
            }
            setLoading(false)
        })
    }

    const get = (name, defaultValue) => _.get(values, name) ?? defaultValue

    const reset = () => {
        setLoading(true)
        setValues()
        setTimeout(() => {
            localStorage.setItem(name, JSON.stringify(defaultValue))
            window.dispatchEvent(new Event('my_storage'))
            setValues(defaultValue)
            setLoading(false)
        })
    }

    return {
        get,
        name,
        reset,
        values,
        commit,
        defaultValue,
    }
}

export const useCodiBookmark = (codi_id, {
    onSuccess = (row) => {
    }
} = {}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const {values, commit, ...rest} = useCodiSettings({
        defaultValue: {},
        name: 'codi-configs',
    })

    const history = useHistory()

    const {handleAsyncAction: mark = NullAsDefault} = useAsyncAction({
        apiInfo: bookmarks_mark_Api,
        query: bindQueryParams([
            {container: AppEntities.USER},
            {container_id: getId(login)},
        ]),
        onError: notifyOnError(t),
        onSuccess: (__, {response}) => {
            const row = getResponseItem(response)?.owner
            onSuccess(row)
            Modal.confirm({
                icon: <BsBookmarkCheckFill style={{ color: '#48bb70' }} className="anticon" />,
                destroyOnHidden: true,
                className: 'custom-modal',
                content: (
                    <div className="flex flex-col gap-1">
                        <span className="font-medium text-sm text-gray-800">
                            {t('bookmarked')}
                        </span>
                        <span className="text-color-300 tracking-wider italic">
                            {t('You can review it in My Activity → Bookmarks Would you like to go there now')}
                        </span>
                    </div>
                ),
                okText: t('go to'),
                okButtonProps: {
                    color: 'primary',
                    className: 'rounded-lg no-shadow no-text-shadow',
                },
                onOk: () => (
                    history.push({
                        pathname: staticPaths.myActivities.pathname,
                        search: '?' + 'rel=my-bookmarks'.toString(),
                    })
                ),
                onCancel: () => (
                    history.listen(() => {
                        Modal.destroyAll()
                    })
                ),
                cancelText: t('got it'),
                cancelButtonProps: {
                    type: 'text',
                    className: 'button-rounded-lg no-border text-color-200',
                }
            })
            // successNotify(NotificationActionTypes.INFORMATION, t)
        },
    })

    const {handleAsyncAction: unmark = NullAsDefault} = useAsyncAction({
        apiInfo: bookmarks_unMark_Api,
        onError: notifyOnError(t),
        onSuccess: (__, {response}) => {
            const row = getResponseItem(response)?.owner
            onSuccess(row)
            Modal.confirm({
                icon: <BsBookmarkX className="anticon" />,
                closable: true,
                destroyOnHidden: true,
                className: 'custom-modal',
                content: (
                    <div className="flex flex-col gap-1">
                        <span className="font-medium text-sm text-gray-800">
                            {t('unbookmark')}
                        </span>
                        <span className="text-color-300 tracking-wider italic">
                            {t('You have removed this item from your favorites. You can add it back by clicking this button again')}
                        </span>
                    </div>
                ),
                okButtonProps: {
                    hidden: true,
                },
                cancelText: t('got it'),
                cancelButtonProps: {
                    type: 'text',
                    className: 'button-rounded-lg no-border text-color-200',
                },
                onCancel: () => (
                    history.listen(() => {
                        Modal.destroyAll()
                    })
                ),
            })
            // successNotify(NotificationActionTypes.INFORMATION, t)
        },
    })

    const codi = _.get(values, codi_id)

    const {lasted} = codi ?? {}

    const withCodi = (values) => ({
        ...(codi ?? {}),
        ...(values ?? {}),
    })

    const isBookmark = (item) => Boolean(item?.bookmark_status)

    const bookmark = (item) => {
        mark(
            {},
            {
                id: getId(item),
                type: getType(item),
                container_id: getId(login),
                container: AppEntities.USER,
            }
        )
    }

    const unbookmark = (item) => {
        unmark(
            {},
            {
                id: getId(item),
                type: getType(item),
                container_id: getId(login),
                container: AppEntities.USER,
            }
        )
    }

    const toggle = (item) => {
        if (_.isEmpty(item)) return
        if (isBookmark(item)) {
            unbookmark(item)
        } else {
            bookmark(item)
        }
    }

    const setLasted = (row_id) => {
        commit({
            [codi_id]: withCodi({
                lasted: row_id,
            }),
        })
    }

    const isLasted = (row_id) => lasted === row_id

    return {
        ...rest,
        lasted,
        toggle,
        isLasted,
        bookmark,
        setLasted,
        isBookmark,
    }
}

const CodiBookmark = ({codi_id, children}) => {
    const {lasted, toggle, bookmark, setLasted, isBookmark, ...rest} =
        useCodiBookmark(codi_id)
    if (_.isEmpty(codi_id)) {
        return null
    }
    return _.isFunction(children)
        ? children({
            ...rest,
            lasted,
            toggle,
            bookmark,
            setLasted,
            isBookmark,
        })
        : children ?? null
}

export default CodiBookmark
